import { render, staticRenderFns } from "./MedicalCertificates.vue?vue&type=template&id=430a377b"
import script from "./MedicalCertificates.vue?vue&type=script&lang=ts"
export * from "./MedicalCertificates.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports